import { useEffect } from "react";
import { toast } from "react-toastify";
import i18n from "../../../Langues/i18n";

const RelaunchToast = ({ isOpen, nbModified, nbSelected, errcount, }) => {
  useEffect(() => {
    if (!isOpen) return;

    if (errcount > 0) {
      toast.error(i18n.t("Error(s) while updating documents!", { errcount }), {
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
       toast.success(i18n.t("updateDocuments", { nbModified, nbSelected }), {
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }, [isOpen, nbModified, nbSelected, errcount]);

  if (!isOpen) return null;

};

export default RelaunchToast;
